<template lang="pug">
  div
    get-container-bounds(v-if='enableInteractionForThisTransform',:container='innerContainer',:render-tools='renderTools')
      template(#default="{bounds,container,updateContainerBounds,worldPos}")
        slot(name='default',
              :update-container-bounds='updateContainerBounds',
              :holder='holder',
              :transform='transform')
        interactive(@select='onSelect',
                    @select-add='onSelectAdd',
                    @selection-change='onSelectionChange',
                    @drag-start='onDragStart'
                    @drag-end='onDragEnd'
                    :render-tools='renderTools',
                    :update-container-bounds='updateContainerBounds',
                    :holder='holder',
                    :bounds='bounds',
                    :container='outerContainer',
                    :transform='transform',
                    :parent-transform='parentTransform',
                    :context='context',
                    :is-indirectly-selected='indirectSelections[transform.id] || indirectSelections[parentTransform.id] || selections[parentTransform.id]',
                    :is-selected='selections[transform.id]',
                    :partutil='partutil',
                    :key='transform.id',
                    v-bind='rest'
                    )
          template(#default='{indirectTransform}')
            .selectionjs-target(:data-transform-id='transform.id')
          template(#selected="{bounds,transform,holder,isIndirectlySelected,isSelected,indirectTransform}")
            //cache-as-bitmap(v-if='isSelected && !isIndirectlySelected',
                            :container='outerContainer',
                            :render-tools='renderTools',
                            @uncached='isCached = false',
                            @cached='isCached = true;')
              h1.title Cached!!
            //@dragged='outerContainer.containerUpdateTransform()',
            slot(name='selected',
              v-bind:bounds='bounds',
              v-bind:worldPos='worldPos',
              v-bind:transform='transform',
              v-bind:parentTransform='parentTransform',
              v-bind:updateContainerBounds='updateContainerBounds',
              v-bind:indirectlySelected='isIndirectlySelected',
              v-bind:isSelected='isSelected',
              v-bind:indirectTransform='indirectTransform',
              v-bind:handlers="{onDragStart,onDragEnd}",
              v-bind:holder='holder',
              v-bind='rest'
              )
</template>
<script>
import { findDbEntry } from '@edit/tree/componentsdb.js';
import { mapState } from 'vuex';
import PbcCircle from '@edit/atoms/Circle.vue';
import Overlay from '@edit/atoms/Overlay.vue';
import CacheAsBitmap from '@edit/atoms/CacheAsBitmap.vue';
import Resize from '@edit/molecules/Resize.vue';
import Interactive from '@edit/atoms/Interactive.vue';
import GetContainerBounds from '@edit/atoms/GetContainerBounds.vue';
export default {
  props: {
    allLoaded:{
      type:Boolean,
      required:true
    },
    holder:{
      type: Object,
      required: true
    },
    outerContainer: {
      type: Object,
      required: true
    },
    innerContainer: {
      type: Object,
      required:true,
    },
    displayObject: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    parentTransform:{
      type: Object,
      required: true
    },
    parentContainer: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    selections: {
      type: Object,
      default() {
        return {};
      }
    },
    anyParentSelected: {
      type: Boolean,
      default: false
    },
    indirectSelections:{
      type: Object,
      defauilt() {
        return {}
      }
    },
    context: {
      type: Object,
      default() {
        return {}
      }
    },
    enableInteraction: {
      type: Boolean,
      default: true
    },
    unselectableTransforms: {
      type: Array,
      default() {
        return [];
      }
    },
    rest:{
      type: Object,
      required: true
    }
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    const dbentry = findDbEntry(component);
    return {
      isCached: false,
      enableCaching: true,
      component,
      dbentry
    }
  },
  components: {
    CacheAsBitmap,
    Resize,
    Overlay,
    EditTransform: () => import ('./EditTransform.vue'),
    GetContainerBounds,
    Interactive,
    PbcCircle
  },
  computed: {
    originalTransform() {
      return this.transform;
    },
    outerTransform() {
      return this.transform;
    },
    enableInteractionForThisTransform() {
      const basic = this.enableInteraction && this.allLoaded && (!this.unselectableTransforms.length || this.isSelectableTransform(this.transform));
      const layerCheck = this.isSelectableLayer(this.transform.layer);
      return basic && layerCheck && ((!this.isAdvancedMode && !this.isFunky) || this.isAdvancedMode);
    },
    isFunky() {
      return this.dbentry.funky;
    },
    ...mapState(['drawAnchorForTransformId', 'isAdvancedMode'])
  },
  mounted() {
  },
  methods: {
    isSelectableTransform(transform) {
      const canSelect = !this.unselectableTransforms.includes(transform.id);
      return canSelect;
    },
    isSelectableLayer(layer) {
      return this.isAdvancedMode || (layer !== "background" && layer !== "meme_template")
    },
    isDrawAnchor(transform) {
      return this.drawAnchorForTransformId === transform.id;
    },
    onSelectionChange({transform,isSelected}) {
      const id = transform.id;
      if (isSelected && !this.selections[id] && !this.indirectSelections[id]) {
        this.$set(this.indirectSelections, id, true);
      } else if (!isSelected && this.indirectSelections[id]) {
        this.$set(this.indirectSelections, id, false);
      }
    },
    shorten(id) {
      return id.slice(0,4)
    },
    onDragStart(updateContainerBounds, holder) {
      this.enableCaching = false;

      const id = this.transform.id;
      const {x,y} = this.transform.transform.pos;
      const data = [{
        id,
        x,
        y,
        indirectlySelected: false,
        holder,
        updateContainerBounds
      }]
      this.$emit('drag-start', {data});
    },
    onDragEnd(updateContainerBounds, holder) {
      this.enableCaching = true;

      const id = this.transform.id;
      const {x,y} = this.transform.transform.pos;
      const data = [{
        id,
        x,
        y,
        indirectlySelected: false,
        holder,
        updateContainerBounds
      }]
      this.$emit('drag-end', {data});
    },
    onSelect({transform, bounds, container, updateContainerBounds, holder}) {
      if (!this.selected) {
        this.$emit("select", {
          transform,
          bounds,
          container,
          holder,
          updateContainerBounds
        });
      } else {
        this.$emit("deselect", {
          transform,
          bounds,
          container,
          holder,
          updateContainerBounds
        });
      }
    },
    onSelectAdd({transform, bounds, container, updateContainerBounds, holder}) {
      if (!this.selected) {
        this.$emit("select-add", {
          transform,
          bounds,
          container,
          holder,
          updateContainerBounds
        });
      } else {
        this.$emit("deselect", {
          transform,
          bounds,
          container,
          holder,
          updateContainerBounds
        });
      }
    },

  }
}
</script>
